// Pagination footer for CRM lists. Mirrors the DashboardV2 DataTable pagination
// (range on the left, page stepper on the right, hairline on top) so a CRM table
// ends the same way a Projects or Team table does. Pages are 1-based here even
// though most CRM screens keep 0-based state — convert at the call site.

import React from "react";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export default function TableFooter({ page, pages, total, pageSize, shown, label = "rows", onChange }) {
  if (!pages || pages <= 1) return null;

  const from = pageSize ? (page - 1) * pageSize + 1 : null;
  const to = pageSize
    ? (shown != null ? from + Math.max(shown, 1) - 1 : Math.min(page * pageSize, total))
    : null;

  const btn = (disabled, onClick, children, label2) => (
    <button
      type="button" onClick={onClick} disabled={disabled} aria-label={label2}
      style={{
        width: 28, height: 28, display: "inline-flex", alignItems: "center", justifyContent: "center",
        borderRadius: 6, border: "1px solid var(--color-border-subtle)", background: "var(--color-bg-surface)",
        color: disabled ? "var(--color-text-muted)" : "var(--color-text-primary)",
        cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1,
      }}
    >{children}</button>
  );

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap",
      padding: "12px 20px", borderTop: "1px solid var(--color-border-subtle)",
    }}>
      <span style={{ fontSize: 12, color: "var(--color-text-muted)", fontVariantNumeric: "tabular-nums" }}>
        {total != null && from ? `${from}–${to} of ${total} ${label}` : `Page ${page} of ${pages}`}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {pages > 2 && btn(page <= 1, () => onChange(1), <ChevronsLeft size={15} />, "First page")}
        {btn(page <= 1, () => onChange(page - 1), <ChevronLeft size={15} />, "Previous page")}
        <span style={{ fontSize: 12, color: "var(--color-text-secondary)", minWidth: 62, textAlign: "center", fontVariantNumeric: "tabular-nums" }}>
          {page} / {pages}
        </span>
        {btn(page >= pages, () => onChange(page + 1), <ChevronRight size={15} />, "Next page")}
        {pages > 2 && btn(page >= pages, () => onChange(pages), <ChevronsRight size={15} />, "Last page")}
      </div>
    </div>
  );
}
